import { BROADCAST_EVENTS, ORDER_AUTH_BROADCAST_CHANNEL } from './auth-broadcast-channel.constants';

/**
 * We use the Broadcast Web API to communicate between browser tabs (log in, log out, etc.),
 * when the current auth status changes.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/BroadcastChannel
 */
export function initAuthBroadcastChannel() {
  return new BroadcastChannel(ORDER_AUTH_BROADCAST_CHANNEL);
}

export function broadcastLogInEvent(authBroadcastChannel: AuthBroadcastChannel) {
  authBroadcastChannel.postMessage(BROADCAST_EVENTS.LOG_IN);
}

export function broadcastLogOutEvent(authBroadcastChannel: AuthBroadcastChannel) {
  authBroadcastChannel.postMessage(BROADCAST_EVENTS.LOG_OUT);
}

export function addBroadcastEventsListener(authBroadcastChannel: AuthBroadcastChannel) {
  authBroadcastChannel.addEventListener('message', handleAuthBroadcastEvent);
}

export function removeBroadcastEventsListener(authBroadcastChannel: AuthBroadcastChannel) {
  authBroadcastChannel.removeEventListener('message', handleAuthBroadcastEvent);
}

export function closeAuthBroadcastChannel(authBroadcastChannel: AuthBroadcastChannel) {
  authBroadcastChannel.close();
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

function handleAuthBroadcastEvent(event: BroadcastMessageEvent) {
  const { data: eventName } = event;

  if (!checkIfAuthEvent(eventName)) return;

  handleAuthChange();
}

function handleAuthChange() {
  window.location.reload();
}

function checkIfAuthEvent(eventName: string) {
  return Object.values(BROADCAST_EVENTS).includes(eventName);
}

// ─── Types ───────────────────────────────────────────────────────────────────

type AuthBroadcastChannel = ReturnType<typeof initAuthBroadcastChannel>;

type BroadcastMessageEvent = BroadcastChannelEventMap['message'];
